module.exports = __webpack_public_path__ + "img/company6-1.349646af.png";